import gql from 'graphql-tag'
import { notificationFragment } from "@/graphql/notification/notificationFragments";
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";
import { projectFragment } from "@/graphql/project/projectFragments";
import { customerFragment} from "@/graphql/customer/customerFragments"
import { customerContactFragment } from "@/graphql/customer/customerContactFragments"
import { customerLocationFragment } from "@/graphql/customer/customerLocationFragments"
import { tagFragment, customTagFragment, customTagLabelFragment } from '@/graphql/tag/tagFragments'
import { resourceFragment, resourceTypeFragment/*, staffVehiculeFragment*/ } from "@/graphql/resource/resourceFragments";

export const NOTIFICATIONSCOUNT = gql`
    query notificationsCount(
        $projectID: ID
    ){
        notificationsCount(
            projectID: $projectID
        ){
            allErrors
            unreadErrors
            allUpcomingErrors
            unreadUpcomingErrors
            allMessages
            unreadMessages
            pendingAssigmnents
            unreadProjectMessages
            unreadProjectErrors
        }
    }
`

export const CONVERSATIONSLIST = gql`
    query conversationsList(
        # $id: [ID]
        $subscribe: Boolean
        $projectID: ID
        #$type: [NotificationType] = [REPLY, INFO]
        $type: [NotificationType] = [REPLY, INFO, SENT]
        $page: Int
        $first: Int
        $unread: Boolean
        $orderBy: String = "updated_at"
        #$orderBy: String = "id"
        $orderSort: SortOrder = DESC
    ){
        conversationsList(
            # id: $id
            subscribe: $subscribe
            type: $type
            projectID: $projectID
            page: $page
            first: $first
            unread: $unread
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...notificationFragment
                recipients{
                    id
                    name
                    email
                }
                created_by{
                    id
                    name
                    email
                }
                updated_by{
                    id
                    name
                    email
                }
                project{
                    id
                    name
                    start_date
                    description
                }
                assignment{
                    id
                    assignedTo{
                        id
                        name
                        email
                    }
                }
                lastConversation{
                    id
                #    subject
                    message
                    read
                    created_by{
                        id
                        name
                        email
                    }
                    created_at
                }
                #conversations{
                #    id
                ##    subject
                #    message
                #    created_by{
                #        id
                #        name
                #        email
                #    }
                #    created_at
                #}
            }
        }
    }
    ${notificationFragment}
`


export const INBOX = gql`
    query inbox(
        $id: [ID]
        $subscribe: Boolean
        $type: [NotificationType]
        $projectID: ID
        $page: Int
        $first: Int
        $unread: Boolean
        $upcomingAssignmentErrors: Boolean
        $orderBy: String = "updated_at"
        $orderSort: SortOrder = DESC
    ){
        inbox(
            id: $id
            subscribe: $subscribe
            page: $page
            first: $first
            type: $type
            unread: $unread
            upcomingAssignmentErrors: $upcomingAssignmentErrors
            projectID: $projectID
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...notificationFragment
                recipients{
                    id
                    name
                    email
                }
                created_by{
                    id
                    name
                    email
                }
                updated_by{
                    id
                    name
                    email
                }
#                conversations{
#                id
#                    message
#                    created_by{
#                        id
#                        name
#                        email
#                    }
#                    created_at
#                }
            }
        }
    }
    ${notificationFragment}
`
export const NOTIFICATIONDETAILS = gql`
    query notificationDetails(
        $id: ID!
    ){
        notificationDetails(
            id: $id
            trashed: WITH
        ){
            ...notificationFragment
            project{
                id
                name
                start_date
                description
            }
            assignments_details {
                start_date
                end_date
                professions {
                    id
                    name
                }
                count
                debug
            }
            assignment{
                date
                id
                assignedTo{
                    id
                    name
                    email
                }
            }
            conversations{
                id
                info
                subject
                type
                message
                replying_to_id
                replying_to_message
                infoAssignment{
                    id
                    date
                    profession{
                        id
                        name
                    }
                    assignedTo{
                        id
                        name
                        email
                    }
                }
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
            lastConversation{
                id
            #    subject
                message
                read
                created_by{
                    id
                    name
                    email
                }
                created_at
            }
            recipientsList{
                id
                name
                email
            }

        }
    }
    ${notificationFragment}
`

export const INBOXDETAILS = gql`
    query inbox(
        $id: [ID]
        $subscribe: Boolean
        $type: [NotificationType]
        $projectID: ID
        $page: Int
        $first: Int
        $unread: Boolean
        $orderBy: String = "updated_at"
        $orderSort: SortOrder = DESC
    ){
        inbox(
            id: $id
            subscribe: $subscribe
            page: $page
            first: $first
            type: $type
            unread: $unread
            projectID: $projectID
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...notificationFragment
                relationsData

                recipients{
                    id
                    name
                    email
                }
                created_by{
                    id
                    name
                    email
                }
                updated_by{
                    id
                    name
                    email
                }
                conversations{
                    id
                    info
                    subject
                    type
                    message
                    created_by{
                        id
                        name
                        email
                    }
                    created_at
                }
            }
        }
    }
    ${notificationFragment}
`

export const PROJECTSINBOX = gql`
    query projectsInbox(
        $id: ID
        $userProfileID: ID
        $first: Int = 25
        $page: Int = 1
    ){
        projectsInbox(
            id: $id
            userProfileID: $userProfileID
            page: $page
            first: $first
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...projectFragment
                updated_at
                updated_by{
                    id
                    name
                    email
                }

                assignmentsDateRange(
                    userProfileID: $userProfileID
                ){
                    from
                    to
                    count
                    countCanceled
                    id
                }

                professions{
                    ...tagFragment
                }
                skills{
                    ...tagFragment
                }
                courses{
                    ...tagFragment
                }
                customtags{
                    ...customTagFragment
                    label{
                        ...customTagLabelFragment
                    }
                }
                resources{
                    ...resourceFragment
                    type{
                        ...resourceTypeFragment
                    }
                }

                created_by{
                    id
                    name
                    email
                }
                projectManager{
                    id
                    name
                    email
                }
                supervisor{
                    id
                    name
                    email
                }
                customers{
                    ...customerFragment
                }
                contacts {
                    ...customerContactFragment
                }
                locations {
                    ...customerLocationFragment
                }

            }
        }
    }
    ${projectFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${resourceFragment}
    ${resourceTypeFragment}
    ${customerFragment}
    ${customerContactFragment}
    ${customerLocationFragment}
`